module.exports = __webpack_public_path__ + "static/airplane-chairs-13b448bfa41f6cbe55d86b9921f638d9.png";